export default {"src":"//jsak.mmtcdn.com/tripmoney/apps/landing-pages/_next/static/media/deliveryInProgressNew.6faed5c8.svg","height":20,"width":18};